import * as XLSX from 'xlsx';
import dayjs from 'dayjs';

const DownloadAttendanceReportExcel = (attendanceData, companyName, setOpenBackdrop, dateRange) => {
    const dataList = Array.isArray(attendanceData) ? attendanceData : [];

    if (dataList.length === 0) {
        alert("No data found to export!");
        return;
    }

    if (typeof setOpenBackdrop === 'function') setOpenBackdrop(true);

    try {
        // Date Range Text Format (e.g., "01-07-2026 to 03-07-2026")
        const startDate = dateRange && dateRange[0] ? dayjs(dateRange[0]).format("DD-MM-YYYY") : "N/A";
        const endDate = dateRange && dateRange[1] ? dayjs(dateRange[1]).format("DD-MM-YYYY") : "N/A";
        const dateRangeText = `Date Range: ${startDate} to ${endDate}`;

        // 1. Meta rows for Company Name and Date Range
        const metaData = [
            [companyName || 'COMPANY NAME'],
            ['ATTENDANCE SUMMARY REPORT'],
            [dateRangeText],
            [] // Empty row for spacing
        ];

        // 2. Main Table Headers (Removed Employee ID)
        const headers = [
            "S.No", "Employee Name", "Email", "Address", "Total Days", "Present", "Absent", "Leave", "Holiday"
        ];

        // 3. Map rows data (Removed Employee ID mapping)
        const rows = dataList.map((item, index) => [
            index + 1,
            item.employee_name || 'N/A',
            item.email || '—',
            item.address || '—',
            item.total_days || 0,
            item.present || 0,
            item.absent || 0,
            item.leave || 0,
            item.holiday || 0
        ]);

        // Combine everything into a single sheet array
        const finalSheetData = [...metaData, headers, ...rows];

        // 4. Create Worksheet from Array
        const worksheet = XLSX.utils.aoa_to_sheet(finalSheetData);

        // 5. Column Widths Setup
        const wscols = [
            { wch: 6 },  // S.No
            { wch: 25 }, // Employee Name
            { wch: 25 }, // Email
            { wch: 35 }, // Address
            { wch: 12 }, // Total Days
            { wch: 10 }, // Present
            { wch: 10 }, // Absent
            { wch: 10 }, // Leave
            { wch: 10 }, // Holiday
        ];
        worksheet['!cols'] = wscols;

        // 6. Workbook generation
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Summary");

        const timestamp = dayjs().format("YYYY-MM-DD");
        const fileName = `${(companyName || 'Company').replace(/\s+/g, '_')}_Attendance_${timestamp}.xlsx`;
        
        XLSX.writeFile(workbook, fileName);

    } catch (error) {
        console.error("Excel Generation Error:", error);
        alert("Something went wrong while generating Excel file");
    } finally {
        if (typeof setOpenBackdrop === 'function') setOpenBackdrop(false);
    }
};

export default DownloadAttendanceReportExcel;